import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useCallback, useState } from "./jsx.js";
import { AsyncContext } from "./AsyncContext.js";
export function FetchTracker({ children }) {
    const { fetchContent, runSSE, currentFetchCount: parrentCounter, } = useContext(AsyncContext);
    const [currentFetchCount, setCurrentFetchCount] = useState(0);
    const wrappedFetchContent = useCallback((url) => {
        setCurrentFetchCount((prev) => prev + 1);
        return fetchContent(url).then((result) => {
            setCurrentFetchCount((prev) => prev - 1);
            return result;
        });
    }, [fetchContent]);
    return (_jsx(AsyncContext.Provider, { value: {
            fetchContent: wrappedFetchContent,
            runSSE,
            currentFetchCount: parrentCounter || currentFetchCount,
        }, children: children }));
}
export function useFetchCounter() {
    const { currentFetchCount } = useContext(AsyncContext);
    return currentFetchCount || 0;
}
